// we might want to make this configurable in the future. I'm imagining an option in the dashboard where
// owners can set a default amount of rooms.
export const DEFAULT_AMOUNT_OF_ROOMS = 1;
export const MAIN_ROOM_IDENTIFIER = 'main-room';
